export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const phoneRegex = /^(\+\d{1,3}\s?)?[\d- ]+$/;
